import { compile, type HtmlToTextOptions } from "html-to-text";

import { getHasHtml } from "./_internal/getHasHtml";

const baseCompileFn = compile();

/**
 * Converts rich text into equivalent plain text, stripping inline formatting and preserving list
 * formatting and newlines.
 *
 * @param text - The rich text to convert.
 * @param options - Optional compile options to pass to the `html-to-text` library's compile
 * function to fine-tune the behavior.
 * @returns The equivalently formatted plain text.
 * @example
 * ```ts
 * convertRichTextToPlainText("<p><ol><li>A</li><li>B</li></ol></p>"); // "1. A\n2. B"
 * convertRichTextToPlainText("Hi &amp; Hello,\nWorld"); // "Hi & Hello,\nWorld"
 * ```
 */
export function convertRichTextToPlainText(text: string, options?: HtmlToTextOptions): string {
  const hasHtmlTags = getHasHtml(text);

  if (!hasHtmlTags) {
    return text;
  }

  // (zstanik): Only call the compile function again if options were provided. Otherwise fall back
  // to the base compiler function above, which should be sufficient for most use cases.
  const compileFn = options == null ? baseCompileFn : compile(options);

  // (clewis): In my opinion, the html-to-text library introduces too many consecutive new
  // lines in some cases. Thus, collapse sequences of two newlines into one.
  return compileFn(text).replaceAll("\n\n", "\n");
}
